import ElasticProcessor from '@lib/processors/elastic-processor'

const TABLE_FILTERS = [
  {
    attribute: 'createdAt',
    label: 'Date Created',
    type: 'date',
    icon: 'el-icon-date',
  },
  {
    attribute: 'status',
    label: 'Status',
    icon: 'el-icon-circle-check',
    type: 'select',
    values: [
      {
        label: 'Completed',
        value: 'completed',
      },
      {
        label: 'In Progress',
        value: 'in_progress',
      },
      {
        label: 'Failed',
        value: 'failed',
      },
    ],
  },
]

const TABLE_COLUMNS = [
  {
    name: 'createdAt',
    label: 'Date Created',
    format: 'dateTime',
    icon: 'el-icon-date',
    width: 150,
  },
  {
    name: 'status',
    label: 'Status',
    icon: 'el-icon-circle-check',
    width: 120,
    format: 'capital',
    component: value => ({
      props: {
        allowEmpty: true,
        styleObj() {
          switch (value) {
            case 'completed':
              return { color: '#3bb720' }
            case 'failed':
              return { color: '#fc1e1e' }
            case 'in_progress':
              return { color: '#fbb241' }
            default:
              return {}
          }
        },
        value() {
          switch (value) {
            case 'in_progress':
              return 'In Progress'
            default:
              return value
          }
        },
        badge() {
          let name

          switch (value) {
            case 'in_progress':
              name = 'el-icon-time'
              break
            case 'failed':
              name = 'el-icon-close'
              break
            default:
              name = 'el-icon-check'
          }

          return {
            name,
            pos: 'left',
          }
        },
      },
    }),
  },
]

export default component => ({
  processor: new ElasticProcessor({
    component,
    index: 'provider-publishing-statuses',
    staticDataQuery: {
      filters: [
        {
          attribute: 'providerId',
          comparison: 'eq',
          value: component.provider.id,
        },
      ],
    },
    initialDataQuery: {
      defaultSort: {
        createdAt: 'desc',
      },
    },
  }),
  filters: TABLE_FILTERS,
  columns: TABLE_COLUMNS,
  tableName: 'provider-catalogue',
})
